import ErrorPage from "../../components/error";

export default function Error() {
  return (
	<>
	  <ErrorPage />
	</>
  );
}